import { Box, Flex, Grid, Heading, Text } from '@chakra-ui/react'
import { Section } from '@/components/layout'
import { SectionLabel } from '@/components/typography'
import { useLocale } from '@/i18n'
import { padNumber } from '@/lib/padNumber'
import { ADVISORY_NOTE, SERVICES, SERVICES_LABEL } from './services.data'

export const Services = () => {
  const { locale } = useLocale()

  return (
    <Section id="services">
      <SectionLabel mb="40px">{SERVICES_LABEL[locale]}</SectionLabel>
      <Grid
        templateColumns="repeat(auto-fit, minmax(min(260px, 100%), 1fr))"
        gap="clamp(28px, 3vw, 40px)"
      >
        {SERVICES[locale].map((service, index) => (
          <Box key={service.title} borderTop="2px solid" borderColor="divider" pt="20px">
            <Flex align="baseline" gap="12px">
              <Text
                fontFamily="heading"
                fontWeight="800"
                fontSize="13px"
                letterSpacing="0.14em"
                color="accent"
              >
                {padNumber(index)}
              </Text>
              <Heading as="h3" fontSize="26px" fontWeight="800" letterSpacing="-0.02em">
                {service.title}
              </Heading>
            </Flex>
            {service.badge && (
              <Text
                mt="10px"
                fontSize="11px"
                letterSpacing="0.14em"
                textTransform="uppercase"
                color="accent.700"
              >
                {service.badge}
              </Text>
            )}
            <Text mt="14px" fontSize="15px" lineHeight="1.62">
              {service.line}
            </Text>
          </Box>
        ))}
      </Grid>
      <Text
        mt="48px"
        pt="20px"
        borderTop="2px solid"
        borderColor="divider"
        fontSize="15px"
        lineHeight="1.62"
        maxW="82ch"
        color="muted"
      >
        {ADVISORY_NOTE[locale]}
      </Text>
    </Section>
  )
}
